export default __webpack_public_path__ + "static/media/ryan.4ea21f2d.jpg";